export default __webpack_public_path__ + "fonts/helvetiker_regular.typeface.json";